/* @flow */

import type { ReadOnlyKeyValuePair } from '../../../../helpers/jsHelpers/types';

export const PersonalDataKey: ReadOnlyKeyValuePair<string> = Object.freeze({
  ParentalControl: 'parentalControl',
  PlayingHistory: 'playinghistory',
  UserProfiles: 'userprofiles',
  ViewingHistory: 'viewinghistory',
  Wishlist: 'wishlist',
});
